import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ItemNumberCounter = props => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      borderRadius: '50%',
      textAlign: 'center',
      width: '40px',
      lineHeight: '40px',
      fontSize: '28px',
      border: '2px solid #666'
    },
    children: props.itemNumber
  });
};